import { useCallback, useState } from 'react';

/**
 * Manages local active-tab state for the Native Tabs MBE handler.
 */
export const useActiveTab = (
	initialIndex = 0,
): {
	activeIndex: number;
	handleTabClick: (index: number) => void;
} => {
	const [activeIndex, setActiveIndex] = useState(initialIndex);

	const handleTabClick = useCallback((index: number): void => {
		setActiveIndex(index);
	}, []);

	return { activeIndex, handleTabClick };
};
